// src/components/email/EmailGrupoMembers.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import Swal from 'sweetalert2';

const EmailGrupoMembers = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [grupo, setGrupo] = useState(null);
  const [miembros, setMiembros] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [prospectos, setProspectos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  
  // Form manual
  const [nuevoEmail, setNuevoEmail] = useState('');
  const [nuevoNombre, setNuevoNombre] = useState('');
  const [nuevaEmpresa, setNuevaEmpresa] = useState('');
  
  // Tabs
  const [activeTab, setActiveTab] = useState('clientes');
  
  // ← ← ← AGREGADO: Estado para búsqueda
  const [searchClientes, setSearchClientes] = useState('');
  const [searchProspectos, setSearchProspectos] = useState('');

  useEffect(() => {
    cargarDatos();
  }, [id]);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      
      const grupoRes = await api.get(`/email/grupos/${id}`);
      setGrupo(grupoRes.data.grupo);
      setMiembros(grupoRes.data.grupo.miembros || []);

      const clientesRes = await api.get('/clientes/lista-simple');
      setClientes(clientesRes.data.clientes || []);

      try {
        const prospectosRes = await api.get('/clientes/prospectos/lista-simple');
        setProspectos(prospectosRes.data.prospectos || []);
      } catch (error) {
        console.warn('No se pudieron cargar prospectos:', error);
        setProspectos([]);
      }

    } catch (error) {
      console.error('Error cargando datos:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron cargar los datos'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAgregarDesdeLista = async (item, tipo) => {
    try {
      setGuardando(true);
      
      await api.post(`/email/grupos/${id}/miembros`, {
        miembros: [{
          ClienteId: tipo === 'cliente' ? item.id : null,
          ProspectoId: tipo === 'prospecto' ? item.id : null,
          email: item.email,
          nombre: item.nombre,
          empresa: item.empresa,
          telefono: item.telefono
        }]
      });

      Swal.fire({
        icon: 'success',
        title: '✅ Agregado',
        text: `${item.nombre} agregado al grupo`,
        timer: 1500,
        showConfirmButton: false
      });

      cargarDatos();
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.error || 'No se pudo agregar'
      });
    } finally {
      setGuardando(false);
    }
  };

  const handleAgregarManual = async () => {
    if (!nuevoEmail) {
      Swal.fire({
        icon: 'warning',
        title: 'Email Requerido',
        text: 'El email es obligatorio'
      });
      return;
    }

    try {
      setGuardando(true);
      
      await api.post(`/email/grupos/${id}/miembros`, {
        miembros: [{
          email: nuevoEmail,
          nombre: nuevoNombre,
          empresa: nuevaEmpresa
        }]
      });

      Swal.fire({
        icon: 'success',
        title: '✅ Agregado',
        text: 'Contacto agregado al grupo',
        timer: 1500,
        showConfirmButton: false
      });

      setNuevoEmail('');
      setNuevoNombre('');
      setNuevaEmpresa('');
      cargarDatos();
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.error || 'No se pudo agregar'
      });
    } finally {
      setGuardando(false);
    }
  };

  const handleEliminarMiembro = async (miembroId) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: '¿Eliminar Miembro?',
      text: '¿Estás seguro de eliminar este miembro del grupo?',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#64748b',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (!result.isConfirmed) return;

    try {
      setGuardando(true);
      await api.delete(`/email/grupos/${id}/miembros/${miembroId}`);

      Swal.fire({
        icon: 'success',
        title: '✅ Eliminado',
        text: 'Miembro eliminado del grupo',
        timer: 1500,
        showConfirmButton: false
      });

      cargarDatos();
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo eliminar el miembro'
      });
    } finally {
      setGuardando(false);
    }
  };

  // ← ← ← CORREGIDO: Variables derivadas con filtro de búsqueda
  const clientesDisponibles = clientes.filter(c => 
    !miembros.some(m => m.ClienteId === c.id) &&
    (searchClientes === '' || 
      c.nombre.toLowerCase().includes(searchClientes.toLowerCase()) ||
      c.email.toLowerCase().includes(searchClientes.toLowerCase()) ||
      c.empresa?.toLowerCase().includes(searchClientes.toLowerCase()))
  );
  
  const prospectosDisponibles = prospectos.filter(p => 
    !miembros.some(m => m.ProspectoId === p.id) &&
    (searchProspectos === '' || 
      p.nombre.toLowerCase().includes(searchProspectos.toLowerCase()) ||
      p.email.toLowerCase().includes(searchProspectos.toLowerCase()) ||
      p.empresa?.toLowerCase().includes(searchProspectos.toLowerCase()))
  );

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loading}>Cargando datos...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>👥 Miembros del Grupo</h1>
          <p style={styles.subtitle}>{grupo?.nombre || 'Cargando...'}</p>
        </div>
        <button onClick={() => navigate('/email/grupos')} style={styles.btnSecondary}>
          ← Volver
        </button>
      </div>

      <div style={styles.grid}>
        {/* Panel Izquierdo - Miembros Actuales */}
        <div style={styles.panel}>
          <div style={styles.card}>
            <h2 style={styles.cardTitle}>
              Miembros Actuales ({miembros.length})
            </h2>

            <div style={styles.miembrosList}>
              {miembros.length > 0 ? (
                miembros.map(miembro => (
                  <div key={miembro.id} style={styles.miembroItem}>
                    <div style={styles.miembroInfo}>
                      <div style={styles.miembroEmail}>{miembro.email}</div>
                      <div style={styles.miembroNombre}>
                        {miembro.nombre || 'Sin nombre'} {miembro.empresa ? `• ${miembro.empresa}` : ''}
                      </div>
                    </div>
                    <button
                      onClick={() => handleEliminarMiembro(miembro.id)}
                      style={styles.btnRemove}
                      disabled={guardando}
                    >
                      🗑️
                    </button>
                  </div>
                ))
              ) : (
                <div style={styles.emptyMiembros}>
                  <p>No hay miembros en este grupo</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Panel Derecho - Agregar Miembros */}
        <div style={styles.panel}>
          {/* Tabs */}
          <div style={styles.tabs}>
            <button
              onClick={() => setActiveTab('manual')}
              style={{
                ...styles.tab,
                ...(activeTab === 'manual' ? styles.tabActive : {})
              }}
            >
              ✍️ Manual
            </button>
            <button
              onClick={() => setActiveTab('clientes')}
              style={{
                ...styles.tab,
                ...(activeTab === 'clientes' ? styles.tabActive : {})
              }}
            >
              👔 Clientes ({clientesDisponibles.length})
            </button>
            <button
              onClick={() => setActiveTab('prospectos')}
              style={{
                ...styles.tab,
                ...(activeTab === 'prospectos' ? styles.tabActive : {})
              }}
            >
              🎯 Prospectos ({prospectosDisponibles.length})
            </button>
          </div>

          {/* Tab: Manual */}
          {activeTab === 'manual' && (
            <div style={styles.card}>
              <h2 style={styles.cardTitle}>Agregar Contacto Manual</h2>

              <div style={styles.formGroup}>
                <label style={styles.label}>Email *</label>
                <input
                  type="email"
                  style={styles.input}
                  value={nuevoEmail}
                  onChange={e => setNuevoEmail(e.target.value)}
                  placeholder="contacto@empresa.com"
                  disabled={guardando}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Nombre</label>
                <input
                  type="text"
                  style={styles.input}
                  value={nuevoNombre}
                  onChange={e => setNuevoNombre(e.target.value)}
                  placeholder="Juan Pérez"
                  disabled={guardando}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Empresa</label>
                <input
                  type="text"
                  style={styles.input}
                  value={nuevaEmpresa}
                  onChange={e => setNuevaEmpresa(e.target.value)}
                  placeholder="Empresa S.A."
                  disabled={guardando}
                />
              </div>

              <button
                onClick={handleAgregarManual}
                disabled={guardando || !nuevoEmail}
                style={{
                  ...styles.btnPrimary,
                  opacity: (guardando || !nuevoEmail) ? 0.6 : 1,
                  cursor: (guardando || !nuevoEmail) ? 'not-allowed' : 'pointer'
                }}
              >
                {guardando ? '⏳ Agregando...' : 'Agregar Contacto'}
              </button>
            </div>
          )}

          {/* Tab: Clientes */}
          {activeTab === 'clientes' && (
            <div style={styles.card}>
              <h2 style={styles.cardTitle}>Clientes Registrados</h2>

              <div style={styles.searchBox}>
                <input
                  type="text"
                  placeholder="🔍 Buscar cliente..."
                  style={styles.searchInput}
                  value={searchClientes}
                  onChange={e => setSearchClientes(e.target.value)}
                />
              </div>

              <div style={styles.listaItems}>
                {clientesDisponibles.length > 0 ? (
                  clientesDisponibles.slice(0, 50).map(cliente => (
                    <div key={cliente.id} style={styles.itemRow}>
                      <div style={styles.itemInfo}>
                        <div style={styles.itemName}>{cliente.nombre}</div>
                        <div style={styles.itemEmail}>{cliente.email}</div>
                        {cliente.empresa && (
                          <div style={styles.itemEmpresa}>{cliente.empresa}</div>
                        )}
                      </div>
                      <button
                        onClick={() => handleAgregarDesdeLista(cliente, 'cliente')}
                        disabled={guardando}
                        style={styles.btnAddItem}
                      >
                        ➕
                      </button>
                    </div>
                  ))
                ) : (
                  <div style={styles.emptyLista}>
                    <p>{searchClientes ? 'No se encontraron clientes' : 'No hay clientes disponibles'}</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Tab: Prospectos */}
          {activeTab === 'prospectos' && (
            <div style={styles.card}>
              <h2 style={styles.cardTitle}>Prospectos del CRM</h2>

              <div style={styles.searchBox}>
                <input
                  type="text"
                  placeholder="🔍 Buscar prospecto..."
                  style={styles.searchInput}
                  value={searchProspectos}
                  onChange={e => setSearchProspectos(e.target.value)}
                />
              </div>

              <div style={styles.listaItems}>
                {prospectosDisponibles.length > 0 ? (
                  prospectosDisponibles.slice(0, 50).map(prospecto => (
                    <div key={prospecto.id} style={styles.itemRow}>
                      <div style={styles.itemInfo}>
                        <div style={styles.itemName}>{prospecto.nombre}</div>
                        <div style={styles.itemEmail}>{prospecto.email}</div>
                        {prospecto.empresa && (
                          <div style={styles.itemEmpresa}>{prospecto.empresa}</div>
                        )}
                        {prospecto.estatus && (
                          <div style={styles.itemEstatus}>{prospecto.estatus}</div>
                        )}
                      </div>
                      <button
                        onClick={() => handleAgregarDesdeLista(prospecto, 'prospecto')}
                        disabled={guardando}
                        style={styles.btnAddItem}
                      >
                        ➕
                      </button>
                    </div>
                  ))
                ) : (
                  <div style={styles.emptyLista}>
                    <p>{searchProspectos ? 'No se encontraron prospectos' : 'No hay prospectos disponibles'}</p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════════════
// 🎨 ESTILOS
// ═══════════════════════════════════════════════════════════════════════════
const styles = {
  container: {
    minHeight: 'calc(100vh - 70px)',
    background: 'linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 50%, #f0f9ff 100%)',
    padding: '24px 32px',
    fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif"
  },
  loading: {
    textAlign: 'center',
    padding: '40px',
    fontSize: '16px',
    color: '#64748b'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    background: 'white',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 4px 0'
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: 0
  },
  btnSecondary: {
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
    color: 'white',
    borderRadius: '8px',
    border: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px'
  },
  panel: {
    minWidth: 0
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    marginBottom: '24px'
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '1e293b',
    marginBottom: '20px',
    paddingBottom: '12px',
    borderBottom: '2px solid #e5e7eb'
  },
  tabs: {
    display: 'flex',
    gap: '8px',
    marginBottom: '24px'
  },
  tab: {
    flex: 1,
    padding: '12px 16px',
    background: 'white',
    border: '2px solid #e5e7eb',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  tabActive: {
    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    color: 'white',
    borderColor: '#3b82f6'
  },
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '8px'
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '8px',
    background: 'white',
    transition: 'all 0.2s',
    fontFamily: 'inherit',
    boxSizing: 'border-box'
  },
  btnPrimary: {
    width: '100%',
    padding: '14px 24px',
    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    color: 'white',
    borderRadius: '8px',
    border: 'none',
    fontWeight: '600',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  miembrosList: {
    maxHeight: '600px',
    overflowY: 'auto'
  },
  miembroItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    borderBottom: '1px solid #e5e7eb',
    gap: '12px'
  },
  miembroInfo: {
    flex: 1
  },
  miembroEmail: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1e293b'
  },
  miembroNombre: {
    fontSize: '12px',
    color: '#64748b'
  },
  btnRemove: {
    padding: '8px 12px',
    background: '#fee2e2',
    color: '#ef4444',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'all 0.2s'
  },
  emptyMiembros: {
    textAlign: 'center',
    padding: '40px',
    color: '#64748b'
  },
  searchBox: {
    marginBottom: '16px'
  },
  searchInput: {
    width: '100%',
    padding: '10px 16px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '8px',
    outline: 'none'
  },
  listaItems: {
    maxHeight: '500px',
    overflowY: 'auto'
  },
  itemRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    borderBottom: '1px solid #e5e7eb',
    gap: '12px'
  },
  itemInfo: {
    flex: 1
  },
  itemName: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1e293b'
  },
  itemEmail: {
    fontSize: '12px',
    color: '#64748b'
  },
  itemEmpresa: {
    fontSize: '11px',
    color: '#94a3b8',
    fontStyle: 'italic'
  },
  itemEstatus: {
    fontSize: '10px',
    color: '#10b981',
    background: '#d1fae5',
    padding: '2px 8px',
    borderRadius: '10px',
    display: 'inline-block',
    marginTop: '4px'
  },
  btnAddItem: {
    padding: '8px 12px',
    background: '#dbeafe',
    color: '#1e40af',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'all 0.2s'
  },
  emptyLista: {
    textAlign: 'center',
    padding: '40px',
    color: '#64748b'
  }
};

export default EmailGrupoMembers;